import { createFileRoute } from '@tanstack/react-router';
import BaseView from 'containers/Base/BaseView';
import { baseModuleConfigs } from 'containers/Base/baseModuleConfigs';
import { usePartMutations } from 'containers/Parts/usePartMutations';
import { prefetchGridSchema } from '../-utils/loaders';

function PartsRoute() {
  const { customAdd } = usePartMutations();
  return <BaseView configuration={baseModuleConfigs.Parts} customAdd={customAdd} />;
}

export const Route = createFileRoute('/_authenticated/parts')({
  loader: ({ context }) =>
    prefetchGridSchema(context.queryClient, baseModuleConfigs.Parts.itemType),
  component: PartsRoute,
});
